
import { useDocumentCategories } from "@/lib/api/hooks/document";
import type { FilterSection } from "@/types/filterTypes";
import { useMemo } from "react";
    
export const useProcurementDocumentsFilterSections = (): FilterSection[] => {

  const { data: categoriesData, isFetching, isError, refetch } = useDocumentCategories();
  
    const categoryOptions = useMemo(
      () =>
        (categoriesData?.data ?? []).map((cat: { value: string; displayName: string }) => ({
          value: cat.value,
          label: cat.displayName
        })),
      [categoriesData?.data]
    );
    
  return [
    {
      key: "documentCategory",
      label: "Document Category",
      type: "select",
      options: categoryOptions,
      isFetching,
      isError,
      refetch
    },
    {
      key: "searchBy",
      label: "Search",
      type: "text",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
